import {
  getLoadMoreUserNetworkLeadersListStatus,
  getUserNetworkLeadersList,
  getUserNetworkLeadersListIdsFromState,
  getUserNetworkLeadersListStatus,
  hasNextPageOfUserNetworkLeadersListAvailable,
} from '@ms/yammer-data/dist/domains/userNetworkLeadersList/selectors';

import { useSelector } from '../useSelector';

type UseUserNetworkLeadersListStatus = () => ReturnType<typeof getUserNetworkLeadersListStatus>;
export const useUserNetworkLeadersListStatus: UseUserNetworkLeadersListStatus = () =>
  useSelector(getUserNetworkLeadersListStatus);

type UseLoadMoreUserNetworkLeadersListStatus = () => ReturnType<typeof getLoadMoreUserNetworkLeadersListStatus>;
export const useLoadMoreUserNetworkLeadersListStatus: UseLoadMoreUserNetworkLeadersListStatus = () =>
  useSelector(getLoadMoreUserNetworkLeadersListStatus);

type UseUserNetworkLeadersList = () => ReturnType<typeof getUserNetworkLeadersList>;
/**
 * @deprecated PERFORMANCE This selects a manually-constructed array of UserNetworkLeadersListFields objects,
 * which will return a new instance and force consumers to re-render whenever ANY user entity in the store gets
 * updated. This should be replaced by a `useUserNetworkLeadersIds` selector, and the top-level consuming component
 * can pass each id to a child component which will use `useUserField` or other "field" selectors for each individual
 * field it requires, while managing its own memoization to avoid unnecessary re-renders.
 */
export const useUserNetworkLeadersList: UseUserNetworkLeadersList = () => useSelector(getUserNetworkLeadersList);

type UseHasNextPageOfUserNetworkLeadersListAvailable = () => ReturnType<
  typeof hasNextPageOfUserNetworkLeadersListAvailable
>;
export const useHasNextPageOfUserNetworkLeadersListAvailable: UseHasNextPageOfUserNetworkLeadersListAvailable = () =>
  useSelector(hasNextPageOfUserNetworkLeadersListAvailable);

type UseGetUserNetworkLeadersListIds = () => ReturnType<typeof getUserNetworkLeadersListIdsFromState>;
export const useGetUserNetworkLeadersListIds: UseGetUserNetworkLeadersListIds = () =>
  useSelector(getUserNetworkLeadersListIdsFromState);
